import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { ConvertService } from 'src/app/services/convert.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { FireValidatorsService } from 'src/app/services/fire-validators.service';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { IGenres } from 'src/app/interfaces/book-store';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { FireStorageService } from 'src/app/services/fire-storage.service';

@Component({
  selector: 'app-genres-form',
  templateUrl: './genres-form.component.html',
  styleUrls: ['./genres-form.component.scss']
})
export class GenresFormComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  @ViewChild('iconFile', {static:false}) iconFile: ElementRef;

  ITEM_KEY: any;
  ITEM: any;
  TITLE: any = "Add new genres"
  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  SELECTED_BOOK_FILE: any;
  START_UPLOAD: boolean;
  uploadPercentBookAudioFile: any;

  form: FormGroup;
  name: AbstractControl;
  icon: AbstractControl;
  description: AbstractControl;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthStore,
    public store: BookstoreStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    private storage: FireStorageService,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.required],
      icon: [null,],
      description: [null],
    })
    this.route.params.subscribe(param => {
      const { id } = param;
      if (id !== 'draft') {
        this.ITEM_KEY = param.id;
        this.store.fetchSelectedData(COLLECTION_NAME.BOOK_STORE_GENRES, this.ITEM_KEY, (doc: any) => {
          if (doc) {
            this.TITLE = "Edit genres"
            this.ITEM = doc;
            this.form = this.fb.group({
              name: [null, Validators.required, FireValidatorsService.checkExistByCompany(this.ds.firestoreRef(), null, COLLECTION_NAME.BOOK_STORE_GENRES, "name", this.ITEM.name)],
              description: [null],
              icon: [null, Validators.required],
            })
            const { name, description, icon } = doc;
            this.form.patchValue({
              name, description, icon
            })
            this.inputEl.nativeElement.focus();
            return;
          }
          else {
            this.ITEM = null;
            this.router.navigate([`/book-store/genres`])
          }
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
      }
    })
  }

  async uploadFileBook(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_BOOK_FILE = event.target.files[0];
      if (this.ITEM) {
        if (this.SELECTED_BOOK_FILE) {
          this.START_UPLOAD = true;
          const file: any = this.SELECTED_BOOK_FILE;
          const soundPath = `book_store_books/generes/${this.ITEM.key}/${file.name}`;
          const soundTask = this.storage.uploadSelectedFile(file, soundPath);
          this.uploadPercentBookAudioFile = soundTask.percentageChanges();
          const downloadURL: any = (await soundTask.then(async (f) => {
            return f.ref.getDownloadURL()
          }));
          let fileType = file.type.split('/').slice(0, -1).join('/');
          const files = {
            key: this.ds.createId(),
            filename: soundPath,
            name: file.name,
            downloadUrl: downloadURL,
            fileType: file.type,
            type: fileType,
            fileSize: file.size,
          }
          this.ITEM.file = files;
          this.START_UPLOAD = false;
        }
        this.store.updateItemDownload(COLLECTION_NAME.BOOK_STORE_GENRES, this.ITEM, (success, res) => {
          this.snackBar.open("Icon has been uploaded successful.", "Done", { duration: 1000 });
          this.START_UPLOAD = false;
          this.SELECTED_BOOK_FILE = null
          this.iconFile.nativeElement.value = ""
        })
      }
    }
  }

  async onSave(f: any, isDraft: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    if (this.form.valid) {
      this.form.disable();
      const { name, description, icon } = f;
      const { user } = this.auth;
      const registerStatus = isDraft ? STATUS_OBJECT.draft : STATUS_OBJECT.submitted;
      const item: IGenres = {
        key: this.ITEM ? this.ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name.trim()}`),
        organizationRef: null,
        organizationKey: null,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name.trim(),
        description,
        icon:icon||null,
        file: this.ITEM ? this.ITEM.file : null,
      }
      if (this.SELECTED_BOOK_FILE) {
        this.START_UPLOAD = true;
        const file: any = this.SELECTED_BOOK_FILE;
        const soundPath = `book_store_books/generes/${item.key}/${file.name}`;
        const soundTask = this.storage.uploadSelectedFile(file, soundPath);
        this.uploadPercentBookAudioFile = soundTask.percentageChanges();
        const downloadURL: any = (await soundTask.then(async (f) => {
          return f.ref.getDownloadURL()
        }));
        let fileType = file.type.split('/').slice(0, -1).join('/');
        const files = {
          key: this.ds.createId(),
          filename: soundPath,
          name: file.name,
          downloadUrl: downloadURL,
          fileType: file.type,
          type: fileType,
          fileSize: file.size,
        }
        item.file = files;
        this.START_UPLOAD = false;
      }
      this.store.addItem(COLLECTION_NAME.BOOK_STORE_GENRES, item, (success, res) => {
        if (success) {
          this.snackBar.open("Genres has been saved successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (this.ITEM_KEY) {
          this.router.navigate([`/book-store/genres/submitted`])
        }
      })
    }
    else {
      this.inputEl.nativeElement.focus();
      this.processNew = false;
      this.processClose = false;
    }
  }

  goBack() {
    this.router.navigate([`/book-store/genres/submitted`])
  }

}
